import React from 'react';
import { Card, Pill } from './ui';
import { latestResult, latestFixtures, resultFor, FORM_BADGE, fmtMonthYear } from '../../lib/clubHelpers';

export default function ClubFixtures({ data }) {
  const ov = data?.overview || {};
  const list = latestFixtures(ov, data?.recentFixtures || data?.fixtures);
  return (
    <Card title="Recent fixtures">
      {(Array.isArray(list) ? list.slice(0, 30) : []).map((f, i) => {
        const r = latestResult(f) || resultFor(f, ov?.name);
        const date = f?.starting_at || f?.date;
        const label = f?.name || `${f?.home?.name || '—'} vs ${f?.away?.name || '—'}`;
        return (
          <div key={i} className="i-row">
            <span className="i-mute text-xs" style={{ minWidth: 70 }}>{fmtMonthYear(date)}</span>
            <span className="i-fg text-sm flex-1 text-center truncate mx-2">{label}</span>
            {r && <Pill className={FORM_BADGE[r] || 'i-bd'}>{r}</Pill>}
          </div>
        );
      })}
      {!list.length && <p className="i-dim text-xs">No fixtures available.</p>}
    </Card>
  );
}
